"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PARTNER_ACCOUNT_ID_SESSION = exports.PARTNER_ACCOUNT_ID_HEADER = exports.MONS_CUSTOMER_ID_SESSION = exports.MONS_CUSTOMER_ID_HEADER = exports.LPID_URL_QUERY = exports.EXTERNAL_PASSPORT_APP_DOMAIN_NAME = exports.CSRF_TOKEN_ID = void 0;
var EXTERNAL_PASSPORT_APP_DOMAIN_NAME = exports.EXTERNAL_PASSPORT_APP_DOMAIN_NAME = 'carrierlogistics';
var MONS_CUSTOMER_ID_HEADER = exports.MONS_CUSTOMER_ID_HEADER = '_debug_amz-mons-customer';
var PARTNER_ACCOUNT_ID_HEADER = exports.PARTNER_ACCOUNT_ID_HEADER = '_debug_amz-mons-partner-account';
var MONS_CUSTOMER_ID_SESSION = exports.MONS_CUSTOMER_ID_SESSION = 'monsCustomerId';
var PARTNER_ACCOUNT_ID_SESSION = exports.PARTNER_ACCOUNT_ID_SESSION = 'partnerAccountId';
var LPID_URL_QUERY = exports.LPID_URL_QUERY = 'mons_sel_dir_paid';
var CSRF_TOKEN_ID = exports.CSRF_TOKEN_ID = 'anti-csrftoken-a2z';
//# sourceMappingURL=externalSiteConstants.js.map